import React from 'react'
import { Landing, Dashboard, NewPost, Page } from './pages'
import {  Route, BrowserRouter, Routes, useNavigate  } from 'react-router-dom'
import './App.scss'
const App = () => {
  return (
     <BrowserRouter>
    <Routes>
      <Route path="/">
        <Route
          index
          element={
              <Landing />
          }
        />
      </Route>
      <Route path="dash" element={<Dashboard />} />
      <Route path="new" element={<NewPost />} />
      <Route path="page/:id" element={<Page />} />
    </Routes>
  </BrowserRouter>
  )
}

export default App